<template>
  <div class="systembody">
    <div style="margin-top: 10px;">
      <div class="sectionLargeIcon largeServerIcon"></div>
      <div class="widget clearfix">
        <span class="title" style="font-size: 22px; margin-right: 15px; font-weight: 600 !important; color: #183677;">
          Contacts List</span>
        <div class="widget_inside" style="margin-top: 15px;">
          <SubscribesComp />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SubscribesComp from '@/components/subscribesList/SubscribesComp'
import Auth from '@/services/auth.service.js'
import SideMenu from '@/components/widgets/sideMenu.vue'
import TopBar from '@/components/widgets/TopBar'

export default {
  name: 'upload',
  components: {
    SideMenu,
    TopBar,
    SubscribesComp,
  },
  data: () => ({
    isExtended: true,
  }),
  methods: {
    isExtendedFunc() {
      this.isExtended = !this.isExtended;
    }
  },
  created() {
    document.title = 'Distribution List | clickcall'
    let auth = Auth.checkAuth();
    if (!auth) {
      this.$router.replace({ name: "login" })
    }
  },
}
</script>
<style scoped>

</style>